import * as React from 'react';

import * as ManifestUI from '@project44/manifest-ds';
import { SkeletonText } from '@project44/shared-components';

import { WithLoadingStatusHOC } from '../types';

export const withLoadingStatus: WithLoadingStatusHOC = (
  ReactComponent,
  options,
) => {
  return (props) => {
    const defaultStyles: ManifestUI.CSS = { display: 'flex' };

    return options?.withLoadingStatusOptions?.isLoading ? (
      <SkeletonText
        css={
          options?.withLoadingStatusOptions?.css
            ? { ...options.withLoadingStatusOptions.css, ...defaultStyles }
            : { w: '100%', ...defaultStyles }
        }
      />
    ) : (
      <ReactComponent {...props} />
    );
  };
};
